<template>
    <modal
        @closeModal="$emit('closeModal')"
        :title="currentDomainDetail.traits">
        <h2>{{ $t(currentDomainDetail.title) }}</h2>
        <p v-html="currentDomainDetail.description"></p>
    </modal>
</template>

<script>
// @ is an alias to /src

import Modal from "@/components/modals/Modal.vue";

export default {
    name: "TraitDetailModal",
    components: {
        Modal: Modal
    },
    props: {
        currentDomainDetail: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
        };
    },
    computed: {
    },
    mounted() {
    },
};
</script>

